export default {
  INCOMPLETE_PROFILE_REPOSITORY: Symbol.for('INCOMPLETE_PROFILE_REPOSITORY'),
  GET_INCOMPLETE_PROFILE_QUERY: Symbol.for('GET_INCOMPLETE_PROFILE_QUERY'),
  UPDATE_INCOMPLETE_PROFILE_COMMAND: Symbol.for('UPDATE_INCOMPLETE_PROFILE_COMMAND'),
  INCOMPLETE_PROFILE_STATE_MANAGER: Symbol.for('INCOMPLETE_PROFILE_STATE_MANAGER'),
};
